import React from 'react';
import Question2 from './Question2';

const Questions = () => {
    return (
        <div className='w-[95%] mx-auto'>
            <h1 className='text-5xl text-center font-bold my-10'>Questions Section</h1>
            <div className=''>
                <h1 className='text-3xl'>1. How does React Work?</h1>
                <p className=' font-bold my-2'>The work process of react is given below:</p>
                <p>
                    ReactJS divides the UI into isolated reusable pieces of code known as components. React components work similarly to JavaScript functions as they accept arbitrary inputs called properties or props. It's possible to have as many components as necessary without cluttering your code. A state is a JavaScript object that represents a part of a component. It changes whenever a user interacts with the application, rendering a new UI to reflect the modifications.

                    State management refers to the practice of managing React application states. It includes storing data in third-party state management libraries and triggering the re-rendering process each time data is changed.
                </p>
            </div>

            <Question2></Question2>

            <div>
                <h1 className='text-3xl mt-3'>3. What is the usage of useEffect hook without data load from api?</h1>
                <p className='font-bold my-1'>The usage of useEffect Hook is given below: </p>
                <p>Some examples of side effects are: fetching data, directly updating the DOM, and timers.</p>
                <p>useEffect(callback, dependencies) is the hook that manages the side-effects in functional components. callback argument is a function to put the side-effect logic. dependencies is a list of dependencies of your side-effect: being props or state values.</p>
            </div>
        </div>
    );
};

export default Questions;